import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../../Data/ReduxViewModels/NuclearGaugeStandardisation';
import { InjectedPropsProvider } from '../../../../../Core/InjectedPropsContext';
import { StandardisationInjectedConsumerProps, StandardisationInjectedPropsModifier } from '../../types';
import { getStandardisationProviderProps } from './providerProps';

/**
 * The intention of this class is to apply common logic to all child components that should work consistently across
 * worksheets components that opt into consumption, e.g.:
 *    - Certain conditions should disable all components.
 *    - Save all input onChange values as they are entered, usng the Web API.
 */
let StandardisationInjectedPropsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const dispatch = useDispatch();

  const equipmentId = useSelector((state) => state.gaugeStandardisation.equipmentId);

  const getProviderProps = useCallback(
    (consumerProps: StandardisationInjectedConsumerProps, modifiers: Array<StandardisationInjectedPropsModifier>) =>
      getStandardisationProviderProps(
        consumerProps,
        {
          equipmentId,
          setValue: (update: any) => dispatch(actions.setValue(update)),
          synchronise: () => dispatch(actions.sync()),
        },
        modifiers
      ),
    [equipmentId, dispatch]
  );

  return <InjectedPropsProvider getProviderProps={getProviderProps}>{children}</InjectedPropsProvider>;
};

export { StandardisationInjectedPropsProvider };
export default StandardisationInjectedPropsProvider;
